<glxy-table-container
  class="kb-table-container"
  [columns]="columns()"
  [dataSource]="dataSource"
  [pageSize]="25"
  [pageSizeOptions]="[10, 25, 50]"
  [showFooter]="true"
>
  <glxy-table-content-header [showColumnArrange]="false" [showFilters]="false" [showSort]="false">
    @if (editingEnabled) {
      <button after-search mat-flat-button color="primary" (click)="openCreateKBDialog()">
        <mat-icon>add</mat-icon>
        {{ 'KNOWLEDGE_SHARING.BASE_TABLE.CREATE' | translate }}
      </button>
    }
  </glxy-table-content-header>

  <table mat-table class="kb-table" [trackBy]="trackRow">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>{{ 'KNOWLEDGE_SHARING.BASE_TABLE.COL_NAME' | translate }}</th>
      <td mat-cell *matCellDef="let row">
        <span class="kb-table__name-line">
          <a href="javascript:void(0)" class="kb-table__link" (click)="onNameClick(row)">{{ row.name }}</a>
          @if (isShared(row)) {
            <mat-icon
              class="kb-table__managed-icon"
              [matTooltip]="'KNOWLEDGE_SHARING.SOURCES.MANAGED_BY' | translate: { partner: row.managedBy }"
            >lock</mat-icon>
          }
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>{{ 'KNOWLEDGE_SHARING.BASE_TABLE.COL_DESCRIPTION' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.description }}</td>
    </ng-container>

    <ng-container matColumnDef="sourceCount">
      <th mat-header-cell *matHeaderCellDef>{{ 'KNOWLEDGE_SHARING.BASE_TABLE.COL_SOURCES' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.sourceCount }}</td>
    </ng-container>

    <ng-container matColumnDef="lastModified">
      <th mat-header-cell *matHeaderCellDef>{{ 'KNOWLEDGE_SHARING.BASE_TABLE.COL_LAST_MODIFIED' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.lastModified | date: 'mediumDate' }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="kb-table__actions"></th>
      <td mat-cell *matCellDef="let row" class="kb-table__actions">
        <div class="kb-table__actions-row">
          @if (canShare && shareAsTopLevelAction) {
            <button
              mat-icon-button
              (click)="openShareDialog(row); $event.stopPropagation()"
              [matTooltip]="'KNOWLEDGE_SHARING.BASE_TABLE.SHARE' | translate"
              [attr.aria-label]="'KNOWLEDGE_SHARING.BASE_TABLE.SHARE' | translate"
            >
              <mat-icon>group_add</mat-icon>
            </button>
          }
          <!-- Reserve the kebab slot even when empty so the Share icon stays in a fixed column. -->
          @if (hasRowActions(row)) {
            <button
              mat-icon-button
              [matMenuTriggerFor]="kbMenu"
              [attr.aria-label]="'KNOWLEDGE_SHARING.BASE_TABLE.ROW_ACTIONS' | translate"
              (click)="$event.stopPropagation()"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
          } @else {
            <span class="kb-table__action-spacer" aria-hidden="true"></span>
          }
        </div>
        <mat-menu #kbMenu="matMenu">
          @if (canShare && !shareAsTopLevelAction) {
            <button mat-menu-item (click)="openShareDialog(row)">
              <mat-icon>group_add</mat-icon>
              <span>{{ 'KNOWLEDGE_SHARING.BASE_TABLE.SHARE' | translate }}</span>
            </button>
          }
          @if (!isShared(row) && editingEnabled) {
            <button mat-menu-item disabled>
              <mat-icon>edit</mat-icon>
              <span>{{ 'COMMON.EDIT' | translate }}</span>
            </button>
            <button mat-menu-item (click)="onDelete(row)">
              <mat-icon>delete</mat-icon>
              <span>{{ 'COMMON.DELETE' | translate }}</span>
            </button>
          }
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="[]"></tr>
    <tr mat-row *matRowDef="let row; columns: []" [class.kb-table__row--shared]="isShared(row)"></tr>
    <tr class="kb-table__empty" *matNoDataRow>
      <td [attr.colspan]="columns().length">
        <glxy-empty-state class="kb-table__empty-state" [size]="'small'">
          <glxy-empty-state-hero>
            <mat-icon>{{ isFiltered() ? 'search_off' : 'menu_book' }}</mat-icon>
          </glxy-empty-state-hero>
          <glxy-empty-state-title>
            {{ (isFiltered() ? 'KNOWLEDGE_SHARING.BASE_TABLE.EMPTY_FILTERED_TITLE' : 'KNOWLEDGE_SHARING.BASE_TABLE.EMPTY_TITLE') | translate }}
          </glxy-empty-state-title>
          <p>
            {{ (isFiltered() ? 'KNOWLEDGE_SHARING.BASE_TABLE.EMPTY_FILTERED_DESCRIPTION' : 'KNOWLEDGE_SHARING.BASE_TABLE.EMPTY_DESCRIPTION') | translate }}
          </p>
        </glxy-empty-state>
      </td>
    </tr>
  </table>
</glxy-table-container>
